// Configuração de Temas Baseados nos Orixás
export interface OrixaTheme {
	name: string;
	displayName: string;
	description: string;
	colors: {
		primary: string;
		secondary: string;
		accent: string;
		error: string;
		info: string;
		success: string;
		warning: string;
		surface: string;
		background: string;
		"on-primary": string;
		"on-secondary": string;
		"on-surface": string;
		"on-background": string;
	};
}

// Tema atual ORI (baseado nas cores existentes)
export const oriTheme: OrixaTheme = {
	name: "ori",
	displayName: "ORI",
	description: "Tema padrão do sistema ORI",
	colors: {
		primary: "#A47551",
		secondary: "#7A5C3E",
		accent: "#D9C2A3",
		error: "#C9544D",
		info: "#5A9BC7",
		success: "#3D9B6F",
		warning: "#D4A04A",
		surface: "#FFFFFF",
		background: "#F5F0E6",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#7A5C3E",
		"on-background": "#7A5C3E",
	},
};

// Tema Exú - Preto com textos Vermelhos
export const exuTheme: OrixaTheme = {
	name: "exu",
	displayName: "Exú",
	description: "Guardião dos caminhos - Preto com Vermelho",
	colors: {
		primary: "#000000",
		secondary: "#1F1F1F",
		accent: "#FCA5A5",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FAFAFA",
		background: "#F5F5F5",
		"on-primary": "#DC2626",
		"on-secondary": "#DC2626",
		"on-surface": "#DC2626",
		"on-background": "#DC2626",
	},
};

// Tema Ogum - Vermelho
export const ogumTheme: OrixaTheme = {
	name: "ogum",
	displayName: "Ogum",
	description: "Orixá dos caminhos e da guerra - Vermelho",
	colors: {
		primary: "#DC2626",
		secondary: "#7F1D1D",
		accent: "#FCA5A5",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#FEF2F2",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#7F1D1D",
		"on-background": "#7F1D1D",
	},
};

// Tema Oxóssi - Verde e Azul
export const oxossiTheme: OrixaTheme = {
	name: "oxossi",
	displayName: "Oxóssi",
	description: "Orixá da caça e da fartura - Verde e Azul",
	colors: {
		primary: "#059669",
		secondary: "#0284C7",
		accent: "#6EE7B7",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#ECFDF5",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#065F46",
		"on-background": "#065F46",
	},
};

// Tema Xangô - Marrom e Branco
export const xangoTheme: OrixaTheme = {
	name: "xango",
	displayName: "Xangô",
	description: "Orixá da justiça e dos raios - Marrom e Branco",
	colors: {
		primary: "#92400E",
		secondary: "#78716C",
		accent: "#FED7AA",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#FFFBEB",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#92400E",
		"on-background": "#92400E",
	},
};

// Tema Oxum - Azul Escuro
export const oxumTheme: OrixaTheme = {
	name: "oxum",
	displayName: "Oxum",
	description: "Orixá dos rios e do amor - Azul Escuro",
	colors: {
		primary: "#1E3A8A",
		secondary: "#1E40AF",
		accent: "#DBEAFE",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#F0F9FF",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#1E3A8A",
		"on-background": "#1E3A8A",
	},
};

// Tema Iemanjá - Azul e Branco
export const iemanjaTheme: OrixaTheme = {
	name: "iemanja",
	displayName: "Iemanjá",
	description: "Rainha do mar - Azul e Branco",
	colors: {
		primary: "#0EA5E9",
		secondary: "#0284C7",
		accent: "#BAE6FD",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#F0F9FF",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#0C4A6E",
		"on-background": "#0C4A6E",
	},
};

// Tema Oxalá - Branco
export const oxalaTheme: OrixaTheme = {
	name: "oxala",
	displayName: "Oxalá",
	description: "Pai de todos os orixás - Branco puro",
	colors: {
		primary: "#6B7280",
		secondary: "#9CA3AF",
		accent: "#F3F4F6",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#FAFAFA",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#374151",
		"on-background": "#374151",
	},
};

// Tema Nanã - Roxo e Lilás
export const nanaTheme: OrixaTheme = {
	name: "nana",
	displayName: "Nanã",
	description: "Orixá ancestre - Roxo e Lilás",
	colors: {
		primary: "#7C3AED",
		secondary: "#8B5CF6",
		accent: "#DDD6FE",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#FAF5FF",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#581C87",
		"on-background": "#581C87",
	},
};

// Tema Iansã - Amarelo e Coral
export const iansaTheme: OrixaTheme = {
	name: "iansa",
	displayName: "Iansã",
	description: "Senhora dos ventos e tempestades - Amarelo e Coral",
	colors: {
		primary: "#F59E0B",
		secondary: "#F97316",
		accent: "#FED7AA",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#FFFBEB",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#92400E",
		"on-background": "#92400E",
	},
};

// Tema Ibeji - Azul claro, Rosa e Branco (Erês)
export const ibejiTheme: OrixaTheme = {
	name: "ibeji",
	displayName: "Ibeji",
	description: "Orixás gêmeos da alegria - Azul claro e Rosa",
	colors: {
		primary: "#60A5FA",
		secondary: "#F472B6",
		accent: "#DBEAFE",
		error: "#EF4444",
		info: "#3B82F6",
		success: "#10B981",
		warning: "#F59E0B",
		surface: "#FFFFFF",
		background: "#F0F9FF",
		"on-primary": "#FFFFFF",
		"on-secondary": "#FFFFFF",
		"on-surface": "#1E40AF",
		"on-background": "#1E40AF",
	},
};

// Lista de todos os temas disponíveis
export const availableThemes: OrixaTheme[] = [
	oriTheme,
	oxalaTheme,
	ogumTheme,
	oxossiTheme,
	xangoTheme,
	oxumTheme,
	iemanjaTheme,
	nanaTheme,
	iansaTheme,
	ibejiTheme,
	exuTheme,
];

// Função para obter tema por nome
export function getThemeByName(name: string): OrixaTheme | undefined {
	return availableThemes.find((theme) => theme.name === name);
}

// Função para obter lista de nomes dos temas
export function getThemeNames(): string[] {
	return availableThemes.map((theme) => theme.name);
}
